module.exports = __webpack_public_path__ + "img/no_img_presentation.dfe3840d.png";